module.exports = __webpack_public_path__ + "img/logo-dportnis.png";